import React from 'react'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import nodeEmoji from 'node-emoji';
import _ from 'lodash';

import { Button, ProgressBar, Icon, Dropdown } from 'components'
import { Virtuoso } from 'react-virtuoso'

import * as api from 'api'
import { getTemplate } from 'templates'
import * as actionCreators from 'store/actions'

const keys = Object.keys(nodeEmoji.emoji);

const Container = styled.div`

`

const SandboxModule = props => {
    const {} = props
    const dispatch = useDispatch()
    const user = useSelector(state => state.auth.user)
    const [group, setGroup] = React.useState('symbols')
    
    return (
        <Container>
            <div onClick={() => console.log('hellos')}>tesaaat</div>
        </Container>
    )
}

export default SandboxModule